
/* injects from baggage-loader */

import {USERS} from 'redux/modules/users'

import {
  SITES,
  SITE_ADD,
  SITE_EDIT,
  SITE_DELETE
} from 'redux/modules/sites'

const initialState = {
  isUsersLoading: null,
  isUserAddProccessing: null,
  isSitesLoading: null,
  isSiteAddProccessing: null,
  isSiteAddProccessingErrorMessage: null,
  isSiteDeleteProccessing: null,
  isSiteDeleteProccessingErrorMessage: null,
  isSiteEditProccessing: null,
  isSiteEditProccessingErrorMessage: null
}

export default function(state = initialState, action) {
  switch (action.type) {
    case USERS.REQUEST:
      return {
        ...state,
        isUsersLoading: true
      }
    case USERS.SUCCESS:
    case USERS.FAILURE:
      return {
        ...state,
        isUsersLoading: false
      }
    case SITE_ADD.REQUEST:
      return {
        ...state,
        isSiteAddProccessing: true,
        isSiteAddProccessingErrorMessage: false
      }
    case SITE_ADD.SUCCESS:
      return {
        ...state,
        isSiteAddProccessing: false,
        isSiteAddProccessingErrorMessage: false
      }
    case SITE_ADD.FAILURE:
      return {
        ...state,
        isSiteAddProccessing: false,
        isSiteAddProccessingErrorMessage: action.message
      }
    case SITE_DELETE.REQUEST:
      return {
        ...state,
        isSiteDeleteProccessing: true,
        isSiteDeleteProccessingErrorMessage: false
      }
    case SITE_DELETE.SUCCESS:
      return {
        ...state,
        isSiteDeleteProccessing: false,
        isSiteDeleteProccessingErrorMessage: false
      }
    case SITE_DELETE.FAILURE:
      return {
        ...state,
        isSiteDeleteProccessing: false,
        isSiteDeleteProccessingErrorMessage: action.message
      }
    case SITE_EDIT.REQUEST:
      return {
        ...state,
        isSiteEditProccessing: true,
        isSiteEditProccessingErrorMessage: false
      }
    case SITE_EDIT.SUCCESS:
      return {
        ...state,
        isSiteEditProccessing: false,
        isSiteEditProccessingErrorMessage: false
      }
    case SITE_EDIT.FAILURE:
      return {
        ...state,
        isSiteEditProccessing: false,
        isSiteEditProccessingErrorMessage: action.message
      }
    case SITES.REQUEST:
      return {
        ...state,
        isSitesLoading: true
      }
    case SITES.SUCCESS:
      return {
        ...state,
        isSitesLoading: false
      }
    case SITES.FAILURE:
      return {
        ...state,
        isSitesLoading: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/account/index.js